import { base64 } from "../consts/base64";

export default function CardBoatDetail({
  msg,
  srcImage,
  boatName,
  boatType,
  port,
  registrationNumber,
  passengerCapacity,
}) {
  return (
    <div className="boat">
      <div className="image">
        <img src={srcImage || base64.emptyImage} alt={boatName} />
      </div>
      <div className="detail">
        <div className="header">{boatName}</div>
        <div className="list">
          <div className="list_detail">
            <span className="label">{`${msg.boat_type} : `}</span>
            <span>{boatType}</span>
          </div>
          <div className="list_detail">
            <span className="label">{`${msg.port} : `}</span>
            <span>{port}</span>
          </div>
          <div className="list_detail">
            <span className="label">{`${msg.registration_number} : `}</span>
            <span>{registrationNumber}</span>
          </div>
          <div className="list_detail">
            <span className="label">{`${msg.passenger_capacity} : `}</span>
            <span>{`${passengerCapacity} ${msg.pax}`}</span>
          </div>
        </div>
      </div>
    </div>
  );
}
